// extracted by mini-css-extract-plugin
export default {"favStarIcon":"StarButton_favStarIcon__TNRES","starred":"StarButton_starred__Tj6d+"};